import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTransactions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={35} height={34} fill='none' {...props}>
    <rect width={34} height={34} x={0.667} fill='#E0BC00' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M17.667 12.17h7.5'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M19.332 9.5h4.17c1.335 0 1.665.33 1.665 1.65v3.082c0 1.32-.33 1.65-1.665 1.65h-4.17c-1.335 0-1.665-.33-1.665-1.65V11.15c0-1.32.33-1.65 1.665-1.65'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M10.167 20.795h7.5'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M25.167 19.25a5.246 5.246 0 0 1-5.25 5.25l.787-1.312M10.167 14.75a5.246 5.246 0 0 1 5.25-5.25l-.788 1.313m-2.797 7.312h4.17c1.335 0 1.665.33 1.665 1.65v3.083c0 1.32-.33 1.65-1.665 1.65h-4.17c-1.335 0-1.665-.33-1.665-1.65v-3.083c0-1.32.33-1.65 1.665-1.65'
    />
  </svg>
);
export default SvgTransactions;
